// extracted by mini-css-extract-plugin
export default {"input":"Woa-z","button":"Xoa-z","selected":"Yoa-z","unavailable":"Zoa-z","image":"_oa-z"};